export default __webpack_public_path__ + "9b4b52f9e5c6f57f8860d0e0625e9930.svg";